import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SubstructureType } from 'src/app/core/_models/substructureType';
import { GlobalConstants } from 'src/constants/global.constants';

@Component({
  selector: 'app-dialog-substructure-form',
  templateUrl: './dialog-substructure-form.component.html',
  styleUrls: ['./dialog-substructure-form.component.scss']
})
export class DialogSubstructureFormComponent implements OnInit {
  form: any;
  currentItem: SubstructureType = {};
  CONSTANTS = GlobalConstants;

  constructor(
    public dialogRef: MatDialogRef<DialogSubstructureFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.form = this.formBuilder?.group({
      substructureTypeId: [null],
      code: ['', Validators.required],
      displayName: ['', Validators.required],
      owner: [''],
      creator: ['']
    });

    if (this.data?.substructureType) {
      this.currentItem = this.data.substructureType;
      this.form.reset();
      this.form.patchValue(this.currentItem);
    }
  }

  get formCrls() {
    return this.form?.controls;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
